/**
 * @description: 权限code和路由URL对应map
 */
export const AUTH_CODE_TO_URL_MAP = {
  parts__list_menu: '/xxx',
  ADMIN: ['/xx', '/xxxx'],
}
